












































import Vue from 'vue';
import { ICalendarDoor } from '@/common/interfaces/announcement-bar.interface';
import ChristmasCalendarButton from '@/components/announcementbar/christmas-calendar/subcomponents/ChristmasCalendarButton.vue';

export default Vue.extend({
  name: `ChristmasCalendarContentDoor`,
  components: { ChristmasCalendarButton },
  props: {
    content: {
      required: true,
      type: Object as () => ICalendarDoor,
    },
    isDesktopView: {
      default: false,
      type: Boolean,
    },
    logoPath: {
      required: true,
      type: String,
    },
    showReadMore: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    navigateToLink(): void {
      if(this.content.link) {
        window.location.href = this.content.link;
      }
    },
  },
});
